import { TranslationPack } from '@pega/cosmos-react-core';
import { defaultTranslations } from './defaultTranslations';

const en = {
  ...defaultTranslations,
};

const enUS = {};

const pl = {};

const es = {};

// language param can be removed and navigator.language can be used in place of it to render in browser language
const getTranslations = (language = 'en'): TranslationPack => {
  const languages = new Set([navigator.language, 'en', 'en-US', 'pl', 'es']);
  const locales = Array.from(languages).reduce((acc: { [key: string]: string }, l) => {
    acc[l] = l;
    return acc;
  }, {});

  const localeTranslation = ({ en, enUS, pl, es } as Record<string, any>)[locales[language.replace('-', '')]];
  const mergedTranslations = {
    ...defaultTranslations,
    ...localeTranslation,
  } as TranslationPack;

  return mergedTranslations;
};

export default getTranslations;
